import type { ReactNode } from 'react';
import './MessageItemLayout.css';

export type MessageItemLayoutProps = {
  leading?: ReactNode;
  content: ReactNode;
  meta?: ReactNode;
  align?: 'start' | 'end';
  className?: string;
};

export function MessageItemLayout({
  leading,
  content,
  meta,
  align = 'start',
  className = '',
}: MessageItemLayoutProps) {
  return (
    <div className={`message-item message-item--${align} ${className}`.trim()}>
      {leading && <div className="message-item__leading">{leading}</div>}
      <div className="message-item__body">
        <div className="message-item__content">{content}</div>
        {meta && <div className="message-item__meta">{meta}</div>}
      </div>
    </div>
  );
}
